<template>
  <div>
    <h1>Passwort ändern</h1>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <b-alert v-model="isSucceded" variant="success">
      {{ $t('passwordchange.success') }}
    </b-alert>

    <b-form-group id="input-group-email" label="Verwendete E-Mail Adresse" label-for="input-email">
      <b-form-input
        id="input-email"
        v-model="currentUser.email"
        type="text"
        readonly
        disabled
      ></b-form-input>
    </b-form-group>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit)" @reset.prevent="reset">

        <validation-provider vid="password" rules="required|min:5" ref="oldPassword" name="oldPassword" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-old-password" label="Aktuelles Passwort *" label-for="input-old-password">
            <b-form-input
              id="input-old-password"
              v-model="form.oldPassword"
              :state="onValidateField(valid, errors, changed)"
              type="password"
              placeholder="Aktuelles Passwort angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider vid="newPassword" rules="required|min:5" ref="newPassword" name="newPassword" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-new-password" label="Passwort *" label-for="input-new-password">
            <b-form-input
              id="input-new-password"
              v-model="form.newPassword"
              :state="onValidateField(valid, errors, changed)"
              type="password"
              placeholder="Neues Passwort angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider vid="newPasswordConfirm" rules="required|confirmed:newPassword" name="newPasswordConfirm" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-confirm-password" label="Passwort wiederholen *" label-for="input-confirm-password">
            <b-form-input
              id="input-password-confirm"
              v-model="form.newPasswordConfirm"
              :state="onValidateField(valid, errors, changed)"
              type="password"
              placeholder="Neues Passwort wiederholen"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-button type="submit" variant="primary" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Passwort ändern
        </b-button>
        <b-button type="submit" variant="primary" v-else>Passwort ändern</b-button>
      </b-form>
    </validation-observer>

  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'
  import { mapGetters } from 'vuex'

  const getInitialData = () => ({
    form: {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: ''
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      async onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('profile/CHANGE_PASSWORD', this.form).then(res => {
          const { errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.isSucceded = true
          this.isSubmitting = false
          this.reset()
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    computed: {
      ...mapGetters({ currentUser: 'user/CURRENT_USER' })
    }
  }
</script>
